import { Users } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import useLiveAnalytics from "../hooks/useLiveAnalytics";

export default function AdminLiveUsers() {
  const { report, failed } = useLiveAnalytics("/admin/analytics/users-live", {});
  const data = report?.available ? report.data : null;
  return <Card className="aorra-admin-kpi aorra-admin-kpi--users admin-metric-card">
    <CardContent className="p-6">
      <div className="flex items-center gap-3 mb-3">
        <span className="aorra-admin-kpi-icon"><Users className="w-5 h-5" /></span>
        <span className="aorra-admin-kpi-label">Total usuarios</span>
      </div>
      <h3 className="aorra-admin-kpi-value" data-testid="total-users">{data?.total_users ?? "—"}</h3>
      <p className="aorra-admin-kpi-note" title="Mes calendario UTC">{data ? `+${data.new_users_this_month} este mes` : "Consultando usuarios…"}</p>
      <p className="aorra-admin-kpi-note" role="status">
        {failed || report?.stale ? (data ? "Actualización demorada; se conserva la última lectura." : "Actualización pendiente; reintentaremos automáticamente.") : "Actualización automática cada 30 s"}
        {data?.through && ` · ${new Date(data.through).toLocaleTimeString("es-CO", { timeZone: "America/Bogota" })}`}
      </p>
    </CardContent>
  </Card>;
}
